import type { SemanticHubPage, SemanticPage } from './types';

type BreadcrumbItem = {
  name: string;
  path: string;
};

export function getBreadcrumbItems(page: SemanticPage | SemanticHubPage): BreadcrumbItem[] {
  const items: BreadcrumbItem[] = [
    { name: 'Home', path: '/' },
    { name: 'Docs', path: '/docs' },
  ];

  if (page.path === '/docs') {
    return items;
  }

  if (page.path === '/docs/apps') {
    return [...items, { name: 'Apps', path: '/docs/apps' }];
  }

  if (page.pageType === 'docs-app') {
    return [
      ...items,
      { name: 'Apps', path: '/docs/apps' },
      { name: page.breadcrumbLabel || page.title, path: page.path },
    ];
  }

  return [...items, { name: page.breadcrumbLabel || page.title, path: page.path }];
}
